import styled, { css } from 'styled-components';
import { darken } from 'polished';

interface PrinterProps {
  backgroundColor: string;
  textColor: string;
}

export const PrinterButton = styled.button<PrinterProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  border: none;
  padding: 7px 12px;
  border-radius: 40px;

  transition: all 0.35s ease-in-out;

  ${(props) =>
    css`
      background: ${props.backgroundColor};
      color: ${props.textColor};
    `}

  svg {
    margin-right: 7px;
  }

  &:hover {
    ${(props) =>
      css`
        background: ${darken(0.05, props.backgroundColor)};
      `}
  }
`;
